const itemsReducerDefaultState = {
    hasErrored: false,
    isLoading: false,
    data: []
};

export default (state = itemsReducerDefaultState, action) => {
    switch (action.type) {
        case 'ITEMS_HAS_ERRORED':
            return {
                ...state,
                hasErrored: action.hasErrored,
                isLoading: action.isLoading

            };
        case 'ITEMS_IS_LOADING':
            return {
                ...state,
                isLoading: action.isLoading
            };

        case 'ITEMS_FETCH_DATA_SUCCESS':
            return {
                ...state,
                data: action.items,
                isLoading: action.isLoading,
                hasErrored: action.hasErrored
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/items.js